import {
    Body,
    Box,
    Vec3
} from "cannon-es"
import { AnimationMixer, Object3D } from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader"
// import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module"

import { gsap } from "gsap"

import { randomNum } from "../components/alpha"
import { defPath, fetchPath } from '../config/defPath'
import { PopsController } from "./popsController"
import { QuestionsController } from "./questionsController"
import { useAlert, useSession } from "../hooks/useState"



// ------------------------------------------------------------


export class Collectables {

    #_loader = new GLTFLoader()
    #_draco = new DRACOLoader()

    #_gltf
    #_base
    #_baseMixer
    #_baseAction

    #_positions = [
        {x: 75, y: 0, z: 40},
        {x: -75, y: 0, z: -40},
    ]
    #_models = new Map()

    #_active = {}

    
    constructor(params) {
        // this.#_params = params

        const name = 'base'
        const loadControl = window.loadControl
        
        this.#_base = new Promise( resolve => {
            this.#_loader
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    const scene = gltf.scene

                    const sf = 1.2
                    scene.scale.set(sf,sf,sf)

                    this.#_baseMixer = new AnimationMixer(scene)
                    // this.#_baseMixer.timeScale = 0.25
                    const [clip] = gltf.animations
                    this.#_baseAction = this.#_baseMixer.clipAction(clip)

                    resolve(scene)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })
    }

    async loadCollectables() {

        const name = 'coleccionables_d'
        const loadControl = window.loadControl
        let resp = false

        if (window.drupalSettings && window.drupalSettings.user.uid == 0){
            if (typeof(Storage) !== 'undefined') {      
                resp = useSession.getState().user.collectables
                resp = (resp == 0) ? false : resp
            }
            else {
                resp = 'c03'
            }
        } else {
            // resp = await fetch(`${fetchPath}/aguila/loyalty/collectable`)
            //     .then( r => r.json())
            //     .catch( err => console.log('Collectables failed fetch'))
        }
        if (typeof(Storage) !== 'undefined') {     
            resp = useSession.getState().user.collectables
            resp = (resp == 0) ? false : resp
        }

        this.#_active.id = resp

        // if(this.#_active.id == null || !this.#_active.id) {
        //     console.warn('No collectables avaible')
        //     return
        // }
        
        this.#_draco.setDecoderPath(`${defPath}/assets/glb/draco/`)
        this.#_draco.setDecoderConfig({ type: 'js' })

        this.#_gltf = new Promise( resolve => {
            this.#_loader
            .setDRACOLoader(this.#_draco)
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    const scene = gltf.scene
                    if(this.#_active.id) {
                        scene.children.forEach( col => {
                            col.position.set(0,0,0)
                            const [id, name] = col.name.split('_')
                            this.#_models.set(id, {name, model: col})
                        })
                    }
                    resolve(gltf)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB name "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })

    }

    async addCollectable() {

        if(this.#_active.id == null || !this.#_active.id || this.#_active.id == 0) return


        // wait all be ready
        await this.#_gltf 

        // Choose one position randomly
        const pos = this.#_positions[ randomNum(0, this.#_positions.length) ]

        // Three
            const def = this.#_active.model = new Object3D()
            def.scale.set(5,5,5)
            def.position.copy(pos)

            const coll = this.#_active.coll = this.#_models.get(this.#_active.id).model.clone()

            def.add( await this.#_base )
            def.add( coll )

            window.scene.add(def)
        
        // Cannon
            const body = this.#_active.body = new Body({
                shape: new Box( new Vec3(4,4,4) ),
            })
            body.position.set(pos.x, 4.1, pos.z)

        //

        // const value = this.#_models[a].name.split('_')[1]
        
        let collided = false
        body.addEventListener('collide', (e) => {

            if (collided) return
            collided = true

            this.removeCollectable()

            window.soundController.play('gift', false, 1)

            new PopsController().open('collectable', this.#_active.id)

        })
        
        window.world.addBody(body)

        //

        this.#_baseAction.play()
    }

    removeCollectable(addNew) {

        const mesh = this.#_active.model
        const body = this.#_active.body

        this.#_active.coll = undefined

        const t = gsap.timeline({
            defaults: {
                duration: 0.75,
                ease: 'power1.out'
            },
            onStart() {
                setTimeout(() => {
                    window.world.removeBody( body )
                }, 1)
            },
            onComplete() {
                window.scene.remove( mesh )
                // mixer = undefined
                t.kill()
            }
        })
        t.to(mesh.scale, {
            x: 0.01, y: 0.01, z: 0.01,
            ease: 'back.in(4)',
        }, 0)
        t.to(mesh.rotation, {
            y: Math.PI * 2.5,
        }, 0)

        //

        if (addNew) this.AddCollectable()
    }

    update(delta) {
        if(this.#_active.coll) {
            this.#_baseMixer.update(delta)
            this.#_active.coll.rotation.y += delta * 0.5
        }
    }
}